import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import { STEP_2_VALIDATION_URL } from '../../costants'

import Contractor from '../../components/people/contractor/Contractor'
import { isValidPrivacy, getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import { authFetch } from '../../libs/cookie/Cookie'

import { isEmpty } from '../../libs/validation/stringRegex'
import { objectsNamesValidation } from '../../libs/validation/remoteValidationAbstract'
import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import Input from '../../libs/ui/inputs/Input'
import Select from '../../libs/ui/inputs/Select'
import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { getDispositiviSmart, getFasciaPrezzi } from '../../libs/initialization/remoteInits'

import { smartPhoneUpdate, SmartPhonePageProps, SmartPhonePageState, smartPhonePageInitialState } from './SmartPhonePageSilce'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class SmartPhonePage extends BasePage<SmartPhonePageProps, SmartPhonePageState> {

    constructor (props: any) {
        super (props)

        this.state = {
            ...smartPhonePageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateDispositivi = this.updateDispositivi.bind(this)
        this.updateFasciaPrezzi = this.updateFasciaPrezzi.bind(this)
        this.updateTipologiaApparecchio = this.updateTipologiaApparecchio.bind(this)
        this.updateBrand = this.updateBrand.bind(this)
        this.updateModello = this.updateModello.bind(this)
        this.updatePrezzo = this.updatePrezzo.bind(this)

        this.step2Validation = this.step2Validation.bind(this)
    }
    

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.dispositivi === undefined) {
            getDispositiviSmart (this.updateDispositivi, this.manageExpiredSessions)
        }

        if (this.state.fasciaPrezzi === undefined) {
            getFasciaPrezzi (this.updateFasciaPrezzi, this.manageExpiredSessions)
        }
    }

    render(): ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                            <form id="login_register_form" autoComplete='off'>
                                <LoginRegister 
                                    isLogged={ isLogged } 
                                    isExpire={ this.state.expiredSessionError }
                                    showTitle={ true }
                                    loggedOkCallBack={ this.logUser }
                                    expiredSessionCallbak={ this.manageExpiredSessions }
                                />
                            </form>
                            </header>

                            <form id="smarthpone_form">
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={false}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className="col-12">
                                            <Select 
                                                id="tipologia" label="Tipologia di apparecchio" name="tipologia"
                                                value={this.state.tipologiaApparecchio}
                                                options={this.state.dispositivi}
                                                callback={this.updateTipologiaApparecchio}
                                                error={this.state.tipologiaApparecchioError}
                                                onFocus={ () => this.setState({tipologiaApparecchioError: undefined}) }
                                            />

                                            <Input 
                                                id="marca" label="Marca" name="marca"
                                                value={this.state.brand}
                                                type="text"
                                                callback={this.updateBrand}
                                                regexp={this.isValidName}
                                                errorDisplayMsg='Nome Azienda non valido'
                                                remoteValidation={objectsNamesValidation}
                                                error={this.state.brandError}
                                                onFocus={ () => this.setState({brandError: undefined}) }
                                            />

                                            <Input 
                                                id="modello" label="Modello" name="modello"
                                                value={this.state.modello}
                                                type="text"
                                                callback={this.updateModello}
                                                regexp={this.isValidName}
                                                errorDisplayMsg='Nome Modello non valido'
                                                error={this.state.modelloError}
                                                onFocus={ () => this.setState({modelloError: undefined}) }
                                            />

                                            <Select 
                                                id="prezzo" label="Prezzo di acquisto (€)" name="prezzo"
                                                value={this.state.prezzo}
                                                options={this.state.fasciaPrezzi}
                                                callback={this.updatePrezzo}
                                                error={this.state.prezzoError}
                                                onFocus={ () => this.setState({prezzoError: undefined}) }
                                            />
                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>

                                </Pagination>
                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return smartPhonePageInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        }
        else {
            let tipologiaApparecchioErro = undefined
            let brandErro = undefined
            let modelloErro = undefined
            let prezzoErro = undefined

            let noMotorPrivacyErro = undefined
            let global = undefined

            if ( errorString === 'TIPOLOGIA' ) {
                tipologiaApparecchioErro = 'Selezionare un valore per il campo "Tipologia di apparecchio"'
                global = tipologiaApparecchioErro
            }
            else if ( errorString === 'BRAND' ) {
                brandErro = 'Indicare la marca'
                global = brandErro
            }
            else if ( errorString === 'MODELLO' ) {
                modelloErro = 'Indicare il modello'
                global = modelloErro
            }
            else if ( errorString === 'PREZZO' ) {
                prezzoErro = 'Selezionare un valore per il campo "Prezzo di acquisto"'
                global = prezzoErro
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            }
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,
                
                tipologiaApparecchioError: tipologiaApparecchioErro,
                brandError: brandErro,
                modelloError: modelloErro,
                prezzoError: prezzoErro,

                noMotorPrivacyError: noMotorPrivacyErro,
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            deviceType: this.state.tipologiaApparecchio ?? null,
            deviceBrand: this.state.brand ?? null,
            deviceModel: this.state.modello ?? null,
            devicePurchasePrice: this.state.prezzo ?? null
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    smartPhoneUpdate (this.state)
                )
            }
        )
    }

    // specifici
    private updateDispositivi (resp: any) {
        this.setState ({
            dispositivi: resp
        })
    }
    private updateFasciaPrezzi (resp: any) {
        this.setState ({
            fasciaPrezzi: resp
        })
    }
    private updateTipologiaApparecchio (val: string | undefined) {
        this.saveStateAndRedux({
            tipologiaApparecchio: val,
            tipologiaApparecchioError: undefined
        })
    }
    private updateBrand (val: string | undefined) {
        this.saveStateAndRedux({
            brand: val,
            brandError: undefined
        })
    }
    private updateModello (val: string | undefined) {
        this.saveStateAndRedux({
            modello: val,
            modelloError: undefined
        })
    }
    private updatePrezzo (val: string | undefined) {
        this.saveStateAndRedux({
            prezzo: val,
            prezzoError: undefined
        })
    }

    private async step2Validation () {
        let error = undefined

        if (this.state.altriSinistri === undefined) {
            error = 'SINISTRI'
        }
        else if (this.state.polizzaAttiva === undefined) {
            error = 'POLIZZA'
        }
        else if (
            this.state.polizzaAttiva === true && 
            isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
        ) {
            error = 'SCADENZA_POLIZZA'
        }
        else if (isEmpty(this.state.tipologiaApparecchio)) {
            return 'TIPOLOGIA'
        }
        else if (isEmpty(this.state.brand)) {
            return 'BRAND'
        }
        else if (isEmpty(this.state.modello)) {
            return 'MODELLO'
        }
        else if (isEmpty(this.state.prezzo)) {
            return 'PREZZO'
        }        
        else if (!isValidPrivacy(this.state.noMotorPrivacy, this.state.user !== undefined)) {
            return 'PRIVACY'
        }
        else {
            await authFetch (
                STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        specificData: this.getSpecificDataForSubmit(),
                        privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                        isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
                    })
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }

    private isValidName (name: string |  undefined) {
        return (name !== undefined && name !== '')
            ? name.length >= 2
            : true
    }
    
    
    
}

const mapState = (state: any) => {
  return {
    //isLogged: state.isLogged,
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,
    
    tipologiaApparecchio: state.tipologiaApparecchio,
    brand: state.brand,
    modello: state.modello,
    prezzo: state.prezzo,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user,
  }
}

export default connect(mapState) (SmartPhonePage)